<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-date-picker
					      v-model="secah.collageDate"
					      type="datetime"
						  value-format='yyyy-MM-dd HH:mm:ss'
					      placeholder="选择日期时间">
					    </el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button @click='secahClick'>搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<div>
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column prop="goodsName" width="300" label="商品名称" align="center">
				</el-table-column>
				<el-table-column prop="currentPersonNum" label="当前参与人数" align="center">
				</el-table-column>
				<el-table-column prop="collageStatus" label="拼团状态" align="center">
					<template slot-scope="scope">
						{{scope.row.collageStatus==1?"未上线":scope.row.collageStatus==2?"已上线":"已结束"}}						
					</template>
				</el-table-column>
				<el-table-column prop="collageDate" label="拼团日期" align="center">
				</el-table-column>
				<el-table-column prop="price" label="价格" align="center">
				</el-table-column>
				<el-table-column prop="integral" label="积分" align="center">
				</el-table-column>
				<el-table-column prop="goodsNum" label="拼团商品数量" align="center">
				</el-table-column>
				<!-- <el-table-column prop="gift" label="未拼中人赠送积分*gift%到红利钱包" align="center">
				</el-table-column> -->
				<el-table-column prop="collageMultiple" label="拼团倍数" align="center">
				</el-table-column>
				
				
				
				<el-table-column fixed="right" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<!-- <el-button size="mini" v-if="scope.row.collageStatus==1" @click="edit(scope.row)">编辑</el-button> -->
						<el-button size="mini" v-if="scope.row.collageStatus==1||scope.row.collageStatus==3" type="danger" @click="del(scope.row)">删除</el-button>
						<el-button size="mini" type="success" v-if="scope.row.collageStatus==1" @click="isPut(scope.row,2)">上架</el-button>
						<el-button size="mini" type="warning" v-if="scope.row.collageStatus==2" @click="isPut(scope.row,1)">下架</el-button>	
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
		<el-dialog v-if="dialogVisible"
		custom-class="level" :close-on-click-modal='false' :close-on-press-escape='false'  :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :modal-append-to-body='false'  width="80%">
			<add @closeMoule="closeMoule" :isAdd="isAdd" :goodsCollageId='goodsCollageId'></add>
		</el-dialog>
	</div>
</template>

<script>
	import add from './components/add.vue'
	export default {
		components:{add},
		data() {
			return {
				tableData: [],
				total: 0,
				dialogVisible: false,
				isAdd: true,
				secah: {
					pageSize: 10,
					pageNum: 1,
					collageDate: ""
				},
				goodsCollageId:""

			}
		},
		created() {
			this.getList()
		},
		methods: {
			//关闭新增修改回调
			closeMoule(e){
				this.dialogVisible=false
				if(e){
					this.getList()
				}
				
			},
			//搜索
			secahClick() {
				this.secah.pageNum = 1
				this.getList()
			},
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true				
			},
			//提交
			sub(){
				if (this.form.supplierName.length == 0) {
					this.$message('请输入供货商名称');
					return false
				}
				if (this.form.continuedWeightPrice.length == 0) {
					this.$message('请输入续重金额');
					return false
				}
				if (!this.istwoNum(this.form.continuedWeightPrice)) {
					this.$message('请输入大于0的整数或者保留两位小数的续重金额');
					return false
				}
				this.form.continuedWeightPrice=parseFloat(this.form.continuedWeightPrice)
				if (this.form.continuedWeightType.length == 0) {
					this.$message('请输入选择续重方式');
					return false
				}
				if (this.form.firstWeight.length == 0) {
					this.$message('请输入首重');
					return false
				}			
				if (!this.istwoNum(this.form.firstWeight)) {
					this.$message('请输入大于0的整数或者保留两位小数的首重');
					return false
				}
				this.form.firstWeight=parseFloat(this.form.firstWeight)
				if (this.form.firstWeightPrice.length == 0) {
					this.$message('请输入首重金额');
					return false
				}				
				if (!this.istwoNum(this.form.firstWeightPrice)) {
					this.$message('请输入大于0的整数或者保留两位小数的首重金额');
					return false
				}
				this.form.firstWeightPrice=parseFloat(this.form.firstWeightPrice)
				if (this.form.supplierFreePostage.length == 0) {
					this.$message('请输入免邮费积分');
					return false
				}
				if (this.form.supplierFreePostage === 0) {
					this.$message('请输入正确的积分，积分为大于0的正整数');
					return false
				}
				if (!this.isNum(this.form.supplierFreePostage)) {
					this.$message('请输入正确的积分，积分为大于0的正整数');
					return false
				}
				
				
				var url=this.isAdd?"/goodsCollage/add":"/goodsCollage/update"
				if(this.isAdd){
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.dialogVisible = false
							this.getList()
						}
					})
				}else{
					this.httpPut(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						console.log(res)
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.dialogVisible = false
							this.getList()
						}
					})
				}
			},
			//上下架
			isPut(row,statys){
				this.$confirm('确定' + (statys == 1 ? '下架' : '上架') + '吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					row.collageStatus=statys
				this.httpPut("/goodsCollage/updateCollageStatus", row, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.$message.success('修改成功');
						// this.dialogVisible = false
						this.getList()
					}
				})
				}).catch(() => {
				});
			},
			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/goodsCollage/del?"+this.$qs.stringify({goodsCollageId:row.goodsCollageId})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getList()
						}
					})
				}).catch(() => {
				});
			},
			//修改
			edit(row) {
				console.log(row);
				this.dialogVisible = true
				this.isAdd = false
				this.goodsCollageId=row.goodsCollageId			
			},

			//选择分页条数
			handleSizeChange(e) {
				this.secah.pageNum = 1
				this.secah.pageSize = e
				this.getList()
			},
			//页码
			handleCurrentChange(e) {
				this.secah.pageNum = e
				this.getList()
			},
			//获取数据
			getList() {
				this.httpPost("/goodsCollage/listByPage", this.secah, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.tableData = res.data.content
						this.total = res.data.total
					}
				})

			},
			

		},


	}
</script>

<style scoped lang='scss'>
	.page {
		padding: 20px 0;
	}
	::v-deep .level {
	    margin: 4% auto auto auto !important;
	    max-height: 80vh;
		min-height: 80vh;
		overflow-y: auto;		
	  }
</style>
